import React from "react";
import {Header} from "../components/header.js"
import {Container, Row, Col} from "react-bootstrap";
import {title, inlineBlock, obraText, obraContainer, obraImage, content, paragraph, page, loguitoStyle, quote, description, poem, pintura} from "../styles/obras.module.css";
import {Footer} from "../components/footer.js";
import {Bar} from "../components/bar";
import expresionCorporalImg from "../content/expresioncorporal.jpg";
import {purpleBackgroundColor, purpleColor} from "../components/color.module.css";
import {Title} from "../components/title";
import loguito from "../content/loguito.png";
import r1 from "../content/r1.jpg";
import r2 from "../content/r2.jpg";
import r3 from "../content/r3.jpg";
import r4 from "../content/r4.jpg";
import r5 from "../content/r5.jpg";
import r6 from "../content/r6.jpg";
import r7 from "../content/r7.jpg";
import r8 from "../content/r8.jpg";
import r9 from "../content/r9.jpg";
import r10 from "../content/r10.jpg";
import r11 from "../content/r11.jpg";
import r12 from "../content/r12.jpg";
import r13 from "../content/r13.jpg";
import r14 from "../content/r14.jpg";
import r15 from "../content/r15.jpg";
import r16 from "../content/r16.jpg";
import r17 from "../content/r17.jpg";
import r18 from "../content/r18.jpg";
import r19 from "../content/r19.jpg";
import r20 from "../content/r20.jpg";
import r21 from "../content/r21.jpg";
import r22 from "../content/r22.jpg";
import r23 from "../content/r23.jpg";
import r24 from "../content/r24.jpg";
import r25 from "../content/r25.jpg";
import r26 from "../content/r26.jpg";
import r27 from "../content/r27.jpg";
import r28 from "../content/r28.jpg";
import r29 from "../content/r29.jpg";
import r30 from "../content/r30.jpg";
import r31 from "../content/r31.jpg";
import r32 from "../content/r32.jpg";
import r33 from "../content/r33.jpg";
import r34 from "../content/r34.jpg";
import r35 from "../content/r35.jpg";

function Obras() {
    return <Container fluid={true}>
	<Bar></Bar>
	<Header></Header>
	<Title text={"Obras"} textStyle={purpleBackgroundColor}/>
	<Row className={page}>
	<Col className={obraContainer}>
	<iframe src="https://www.youtube.com/embed/HFG2KF5Rzr8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	<h1 className={`${title} ${purpleColor}`}>Sobre la arteterapia</h1>
	<p className={paragraph}>Es una profesión de ámbito asistencial que se caracteriza por el uso de medios y procesos artísticos para ayudar a contener y solventar los conflictos emocionales o psicológicos de las personas. 
Se caracteriza porque los sentimientos o emociones conflictivas se expresan en vías alternativas a la palabra, mientras que el proceso de creación artístico y el resultado actúan como intermediarios en la relación terapéutica. 
Se puede aplicar en la salud, la educación y la asistencia social. 
El abordaje artístico puede tener múltiples manifestaciones, desde la escritura, el movimiento, el teatro espontáneo, el dibujo, el recorte, los mandalas, la música, entre otros. </p>
	</Col>
	</Row>
	
	<Row className={page}>
	<Col className={obraContainer}>
	<img className={loguitoStyle} src={loguito} alt={"loguito"}/><h1 className={`${title} ${purpleColor} ${inlineBlock}`}>PINTURA</h1>
	</Col>
	</Row>
	<Row className={page}>
		<Col className={obraContainer}>
	<iframe  src="https://www.youtube.com/embed/oEbY8z7E8NA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	<p className={`${paragraph} ${quote}`}>Rostro. “Construir una máscara”. <br/>
Recursos: pintura, movimiento, vocalizacion, escritura. <br/>
	Técnica: pintura sobre tela. intervención con materiales de costura. <br/>
 </p>
	
	</Col>
	
	</Row>

	<Row className={page}>
		<Col className={obraContainer}>
	<img src={r1} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Mi máscara es la muerte” … “se dedica a llevar almas y no le gusta nada” </em></p>
	
    </Col>
	</Row>

	<Row className={page}>
		<Col className={obraContainer}>
	<img src={r2} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Mi máscara lleva tapaboca por el covid” … “le gusta la libertad y proteger a las personas”. A.M</em></p>
	
    </Col>
	</Row>


	<Row className={page}>
		<Col className={obraContainer}>
	<img src={r3} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Mi máscara es Lucio, abogado” … “Le gusta jugar fútbol y no le gusta la falta de sinceridad”. A.M.</em></p>
	
    </Col>
	</Row>

	<Row className={page}>
		<Col className={obraContainer}>
	<img src={r4} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Mi máscara es un comerciante” … “le gusta mucho comer y no le gusta el cigarro ni que fumen” B.M.</em></p>
	
    </Col>
	</Row>


    	<Row className={page}>
		<Col className={obraContainer}>
	<img src={r5} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Mi máscara pintada es parecida a una bailarina” … “se llama Rosa, le gusta modelar y no le gusta nadar”. I.G.</em></p>
	
    </Col>
	</Row>

    	<Row className={page}>
		<Col className={obraContainer}>
	<img src={r6} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Le gusta reír y no le gusta escuchar”. J.F.</em></p>
	
    </Col>
	</Row>


    	<Row className={page}>
		<Col className={obraContainer}>
	<img src={r7} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Le gusta la actividad” K.P.</em></p>
	
    </Col>
	</Row>


    	<Row className={page}>
		<Col className={obraContainer}>
	<img src={r8} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Mi máscara pintada es Nifu Nifa, es animadora” … “le gusta bailar y no pelear.” L.A.</em></p>
	
    </Col>
	</Row>


    	<Row className={page}>
		<Col className={obraContainer}>
	<img src={r9} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Mi máscara es una profesora” … “le gusta maquillarse” M.B.</em></p>
	
    </Col>
	</Row>

    	<Row className={page}>
		<Col className={obraContainer}>
	<img/>
	<img src={r10} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Mi máscara es un programador” … “le gusta el diseño y no le gusta el ruido”. R.H.</em></p>
	
    </Col>
	</Row>

    	<Row className={page}>
		<Col className={obraContainer}>
	<img src={r11} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Mi máscara es María, ella trabaja en su casa y le gusta comer arroz”. T.H.</em></p>
	
    </Col>
	</Row>

	<Row className={page}>
	<Col className={obraContainer}>
	<iframe src="https://www.youtube.com/embed/RMczLIg332Q" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	<p className={`${paragraph} ${quote}`}>PIES Y APOYOS.  “DEJA TUS HUELLAS”. <br/>
TÉCNICA: TEMPERA SOBRE LONETA. INTERVENCIÍN CON LÁPIZ DE CERA. <br/>
RECURSOS: PINTURA, MOVIMIENTO, ESCRITURA, MUSICA.
 </p>
	
	</Col>
	</Row>

        <Row className={page}>
	<Col className={obraContainer}>
	<img src={r13} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“No te detengas” I.G.</em></p>
	
    </Col>
	</Row>

        <Row className={page}>
	<Col className={obraContainer}>
	<img src={r14} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Pies a la piel” J.Z.</em></p>
	
    </Col>
	</Row>

        <Row className={page}>
	<Col className={obraContainer}>
	<img src={r15} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Los pies de Karin Piña” K.P.</em></p>
	
    </Col>
	</Row>

        <Row className={page}>
	<Col className={obraContainer}>
	<img src={r16} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Pie Grande” L.A.</em></p>
    </Col>
	</Row>

        <Row className={page}>
	<Col className={obraContainer}>
	<img src={r17} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Manzana” M.B.</em></p>
    </Col>
	</Row>

        <Row className={page}>
	<Col className={obraContainer}>
	<img src={r18} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Pies sanos” T.H.</em></p>
    </Col>
	</Row>                
    
    	<Row className={page}>
	<Col className={obraContainer}>
	<img className={loguitoStyle} src={loguito} alt={"loguito"}/><h1 className={`${title} ${purpleColor} ${inlineBlock}`}>ESCULTURA</h1>
	</Col>
	</Row>

    	<Row className={page}>
		<Col className={obraContainer}>
<iframe src="https://www.youtube.com/embed/Lu5wu-sBmEE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	<p className={`${paragraph} ${quote}`}>“MIS MANOS MOLDEANDO LA ARCILLA”.<br/>
LENGUAJE ARTÍSTICO: ARCILLA GRIS. <br/>
RECURSOS: ARCILLA, MOVIMIENTO, MÚSICA, ESCRITURA.
 </p>
	
	</Col>
	
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r19} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“La arcilla es relajante”. B.C.</em></p>
	</Col>
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r20} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Me divertí al máximo, nunca había manejado la arcilla en mis manos”. I.G.</em></p>
	</Col>
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r21} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Sentí la mente en algo, hice un cenicero para botar la ceniza”. L.A.</em></p>
	</Col>
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r22} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Hice un plato, una olla, un pocillo y una mandoca”. M.B.</em></p>
	</Col>
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r23} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Al principio sentí como si tuviese las manos metidas en pupú de bebe, luego me gustó porque se sintió fría y es como si estuviese jugando con la arena de la playa”. O.R.</em></p>
	</Col>
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r24} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“Me desestresa, saca mucho de mi mente, cosas que no sabía que existían”. O.R.</em></p>
	</Col>
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r25} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“La arcilla me recuerda a mi infancia”. T.H.</em></p>
	</Col>
	</Row>               

        <Row className={page}>
	<Col className={obraContainer}>
	<img className={loguitoStyle} src={loguito} alt={"loguito"}/><h1 className={`${title} ${purpleColor} ${inlineBlock}`}>EXPRESIÓN CORPORAL</h1>
	</Col>
	</Row>

    	<Row className={page}>
	<Col className={obraContainer}>
	<p className={`${paragraph} ${quote}`}>“IMPROVISACIONES TEATRALES Y ESTATUISMO”<br/>
RECURSOS: GUION DE ESCENAS, ELEMENTOS TEATRALES.  <br/>
LENGUAJES ARTISTICOS: CUERPO Y VOZ.<br/>
 </p>
	
	</Col>
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r26} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“NIFUNIFA” I.G.</em></p>
	</Col>
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r27} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“TORERO” J.Z.</em></p>
	</Col>
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r28} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“VIEJITA RUMBERA” K.P.</em></p>
	</Col>
	</Row>

            <Row className={page}>
	<Col className={obraContainer}>
	<img src={r29} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“MARIACHI” K.P.</em></p>
	</Col>
	</Row>

                <Row className={page}>
	<Col className={obraContainer}>
	<img src={r30} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“EL INGENIERO”. L.A. </em></p>
	</Col>
	</Row>

                <Row className={page}>
	<Col className={obraContainer}>
	<img src={r31} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“EL CONDE” L.A.</em></p>
	</Col>
	</Row>

                    <Row className={page}>
	<Col className={obraContainer}>
	<img src={r32} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“MANIQUÍ” M.B.</em></p>
	</Col>
	</Row>

                    <Row className={page}>
	<Col className={obraContainer}>
	<img src={r33} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“MUÑECA” M.B.</em></p>
	</Col>
	</Row>

        <Row className={page}>
	<Col className={obraContainer}>
	<img src={r34} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“LLANERA”, T.H.           </em></p>
	</Col>
	</Row>

        <Row className={page}>
	<Col className={obraContainer}>
	<img src={r35} className={pintura}/>
	<p className={`${paragraph} ${description}`}> <em>“EL JOROBADO” T.H.</em></p>
	</Col>
	</Row>        

        <Row className={page}>
	<Col className={obraContainer}>
	<img className={loguitoStyle} src={loguito} alt={"loguito"}/><h1 className={`${title} ${purpleColor} ${inlineBlock}`}>ESCRITURA</h1>
	</Col>
	</Row>

    	<Row className={page}>
	<Col className={obraContainer}>
	<p className={`${paragraph} ${quote}`}>LA ESCRITURA ES UN LENGUAJE QUE ESTUVO PRESENTE SIEMPRE PARA ACUNAR LOS SENTIMIENTOS O PARA EXPULSAR EMOCIONES. <br/>
<strong>POESÍA DE UN LAMENTO EN EL TRABAJO DE ARCILLA.</strong>
	</p>
	<p className={`${paragraph} ${description} ${poem}`}>“Si tuviera que escribir todo lo que me hicieron, <br/>
No me alcanzarían las hojas, <br/>
Ni el tiempo, ni el espacio, <br/>
Las pérdidas y desafíos, <br/>
Son tiempos de libertad,<br/>
De mejoría cada día. <br/>
Son tiempos justos,<br/>
Porque Dios es Justo<br/>
Y misericordioso”. <br/>
J.Z.</p>
	</Col>
	</Row>

	<div className={content}>
	<Footer style={purpleBackgroundColor}></Footer>
	</div>

	</Container>;
};

export default Obras;

